(() => {
  let queued = false;
  function enhance() {
    queued = false;
    document.querySelectorAll('.tee-row[role="radiogroup"]').forEach(group => {
      const labels = Array.from(group.querySelectorAll('.tee-radio-label'));
      const none = labels.find(label => /^Kein Teelicht$/i.test(label.textContent.trim()));
      const led = labels.find(label => /^LED[ -]Teelicht\b/i.test(label.textContent.trim()));
      if (!none || !led || labels.length !== 2) return;
      group.classList.add('cuddels-teelicht-options');
      none.classList.add('cuddels-no-teelicht');
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  }
  function start() {
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('teeinblue-event-component-injected', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();